import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const MEDS_BY_PATIENT_URL = `${API_BASE_URL}/api/advancedmd/medications`;

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
});

/**
 * Obtiene los medicamentos de un paciente.
 * @param {string|number} patientId
 */
export async function getPatientMedications(patientId) {
  try {
    const url = `${MEDS_BY_PATIENT_URL}/${encodeURIComponent(patientId)}`;
    const res = await axios.get(url, { headers: authHeader() });
    return res.data;
  } catch (err) {
    console.error("Error getPatientMedications:", err);
    throw err;
  }
}